module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAMgAAAAECAYAAADLcnBRAAABRklEQVRIiZ1VWw7DMAgjvdJOu8Mu7GPN5Lo2ZEOqlGJMEl4Zj2dmfCTPD9fqf+mmwabAZ+GDOWzHfF4rTmXTYfj/EjyFM+b2nIWN84W2zGf/nQ/2FcKn41T+mMu5VRzeu8qhqyFXT1y7rlY7XRygCAYFxjp2jDJAP85PYQEY2lTnYL/I2xU+s7uDWld2Kf53zsIxGIDJvcYdd7Go4pikr/LEPhR3CL2SKoccwxA2zt+yvehErBzngh9xt3ABdpd1h16XRC4GcKeIOEGL90tD7BToP35UEiP0/ZxUMXDFm0TgfWyzjboRu8ZyoopbiWt01Uxd7KrBJXMiYlXt/8UP/EltuHDX0VwMrEOum2QKr/arJpSduJviJrfTOeGJrO7e+etek11dRkRSft0ZOv3O/m5w4Fq9WMufw9BmiDXWR/eauRfzcuY3ZWAi28tdCNMAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/components/anniversary/right-line.png
// module id = l3p+
// module chunks = 0